import { useContext } from 'react';
import { ApuracaoIcmsContextData } from '../../types';
import { ApuracaoIcmsContext } from '../../contexts/ApuracaoIcmsContext';

export const useApuracaoIcms = (): ApuracaoIcmsContextData =>
  useContext(ApuracaoIcmsContext);
